import { ApolloClient, DefaultOptions, HttpLink } from '@apollo/client/core';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { InMemoryCache } from '@apollo/client/cache';

const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
};

export function createClient(uri: string): ApolloClient<unknown> {
    const link = createPersistedQueryLink({
        sha256,
        useGETForHashedQueries: true,
    }).concat(new HttpLink({ uri }));
    return new ApolloClient({
        link,
        devtools: {
            enabled: false,
        },
        cache: new InMemoryCache(),
        defaultOptions,
    });
}
